/**
 * The RepletoryReach wordmark: "Repletory" in the surrounding text colour,
 * "Reach" in the brand primary.
 *
 * The head deliberately inherits `currentColor` rather than hardcoding white.
 * The lockup appears on the dark sidebar, on the dark auth panel and on light
 * surfaces (the mobile drawer, the admin header), so the container decides:
 * white where the ground is dark, the normal text colour where it is not. The
 * accent is the primary in every one of them.
 *
 * `i18n-ignore` throughout: this is the product name, not copy.
 */
export function BrandWordmark({ className }: { className?: string }) {
  return (
    <span className={['rr-brand-name', className].filter(Boolean).join(' ')}>
      {/* i18n-ignore: product name */}
      Repletory<span className="rr-brand-name__accent">Reach</span>
    </span>
  );
}
